<template>
  <div id="app">
    <div class="main" ref="main">
      <router-view></router-view>
    </div>
    <!--<main-footer></main-footer>-->
  </div>
</template>

<script>
//  import MainFooter from "@/components/MainFooter"

  export default {
    name: 'App',
    components: {
//      MainFooter
    },
    mounted() {
      //this.$refs.main.style.minHeight = document.documentElement.clientHeight - 400 + 'px';
      this.$Loading.config({
        color: '#DA2117',
        failedColor: '#db2117',
        height: 4
      });
    }
  }
</script>

<style>
  #app {
    background: #f9f9f9;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue